

const cartGiftWrappingChecker = () => {

  const giftWrapId = window.themeVariables.settings.giftWrapId;

  if (!giftWrapId) return

  const updateGiftWrapCount = async (event) => {
    const cart = event.detail["cart"];
    // if cart includes products with gift wrapping property, update the amount of gift wrapping matches the quantity of the product with the gift wrapping property

    const productsWithGiftWrap = cart.items.filter((item) => {
      return item.properties && item.properties._gift_wrapping !== undefined && item.properties._gift_wrapping !== null;
    });

    const giftWrapItem = cart.items.find((item) => {
      return item.variant_id === giftWrapId;
    });


    if (giftWrapItem && productsWithGiftWrap) {
      const quantity = productsWithGiftWrap.length;

      let updates = {
        [giftWrapId]: quantity
      };

      const cart = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
        .then(response => {

          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });

    } else if (!giftWrapItem && productsWithGiftWrap) {

      const updatesRemove = productsWithGiftWrap.reduce((acc, item) => {
        acc[item.id] = 0;
        return acc;
      }, {});

      const updatesAdd = productsWithGiftWrap.reduce((acc, item) => {
        acc[item.id] = item.quantity;
        return acc;
      }, {});


      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: updatesRemove,
        })
      });

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: updatesAdd,
        })
      });
    }

    document.documentElement.dispatchEvent(new CustomEvent('gift-wrapping:loading', {
      bubbles: true,
    }));

    // Set a timeout to ensure the cart refreshes correctly, when the last item with giftwrap is removed
    setTimeout(() => {
      document.documentElement.dispatchEvent(new CustomEvent('gift-wrapping:loaded', {
        bubbles: true,
      }));

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    }, 100);
  }

  document.addEventListener('cart:updated', (event) => {
    updateGiftWrapCount(event);
  });
}


// document.addEventListener('cart:updated', (event) => {
//   var cart = event.detail.cart; // Get the updated content of the cart
// });

cartGiftWrappingChecker();


class GiftWrapping extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.giftVariantId = this.getAttribute("data-variant-id");
    this.lineKey = this.getAttribute("data-line-item-key");
    this.lineItemQuantity = this.getAttribute("data-line-item-quantity");
    this.lineItemVariantId = this.getAttribute("data-line-item-variant-id");
    this.checkbox = this.querySelector("input[type='checkbox']");
    this.giftWrapTotalQuantity = this.getAttribute(
      "data-gift-wrap-total-quantity"
    );

    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }



  addEventListeners() {
    this.checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
  }

  removeEventListeners() {
    this.checkbox.removeEventListener("change", this.handleCheckboxChange.bind(this));
  }



  async cartHandler(type = "change", body) {
    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const response = await fetch(`${ Shopify.routes.root }cart/${ type }.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...body, ...{ sections: sectionsToBundle } }),
      });

      if (!response.ok) {
        throw new Error("Failed to update cart");
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error("👨🏻‍💻 -> GiftWrapping -> response -> error:", error);
    }
  }

  async addGiftWrapping() {
    // Remove the current line item
    await this.cartHandler("change", {
      id: this.lineKey,
      quantity: 0,
      // quantity: parseInt(this.lineItemQuantity, 10) - 1,
    });

    // Add the gift wrapping line item
    await this.cartHandler("add", {
      id: this.lineItemVariantId,
      quantity: parseInt(this.lineItemQuantity, 10),
      properties: {
        _gift_wrapping: this.lineKey,
        _timestamp: new Date().getTime(),
      },
    });

    // Add the gift wrapping variant
    await this.cartHandler("add", {
      id: this.giftVariantId,
      quantity: 1,
    });

  }

  async removeGiftWrapping() {

    // Remove the gift wrapping variant
    await this.cartHandler("change", {
      id: this.giftVariantId,
      quantity: parseInt(this.giftWrapTotalQuantity, 10) - 1,
    });

    // Remove the gift wrapping line item
    await this.cartHandler("change", {
      id: this.lineKey,
      quantity: 0,
    });

    // Add the original line item
    await this.cartHandler("add", {
      id: this.lineItemVariantId,
      quantity: 1,
    });
  }

  async handleCheckboxChange(event) {
    const isChecked = event.target.checked;
    this.checkbox.disabled = true;
    document.documentElement.dispatchEvent(new CustomEvent('gift-wrapping:loading', {
      bubbles: true,
    }));

    if (isChecked) {
      await this.addGiftWrapping();
    } else {
      await this.removeGiftWrapping();
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    document.documentElement.dispatchEvent(new CustomEvent('gift-wrapping:loaded', { bubbles: true }));
  }

}
if (!window.customElements.get("gift-wrapping")) {
  window.customElements.define("gift-wrapping", GiftWrapping);
}

class GiftWrappingLoader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    document.addEventListener("gift-wrapping:loading", () => {
      this.classList.add("loading");
    });

    document.addEventListener("gift-wrapping:loaded", () => {
      this.classList.remove("loading");
    });

  }
}

if (!window.customElements.get("gift-wrpping-loader")) {
  window.customElements.define("gift-wrpping-loader", GiftWrappingLoader);
}